<app-header (filterChange)="onCategoryFilterChange($event)" (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)" (searchFilterChange)="onSearchFilterChange($event)">
</app-header>
<div class="catlog-page">

  <div>
    <!-- <ul class="breadcrumb">

      <li *ngFor="let item of sortedCategoryHierarchy;let i=index">
        <span>{{ item.value }}</span>
        <i class="ri-arrow-right-s-line"></i>
      </li>
      <span title="{{ msnDetails?.msnName }}" class="text-truncate-breadcrumb">{{ msnDetails?.msnName }}</span>
    </ul> -->

  </div>
  <h1 class="back-heading ">
    <i class="ri-arrow-left-line" (click)="productDiscovery()"></i>
    <span class="text-truncate-breadcrumb">
      {{msnDetails?.msnName}}
    </span>

  </h1>

  <div class="product-info-card">
    <div class="flex product-content">
      <img [src]="getCategoryImage()" alt="" />
      <div>
        <h2 class="d-flex align-items-center">
          {{ productId }}
          <button mat-icon-button class="copy-button ms-2" (click)="copyToClipboard(productId, copyTooltip)"
            matTooltip="Copy MSN" #copyTooltip="matTooltip" matTooltipPosition="above">
            <mat-icon class="copy-icon">content_copy</mat-icon>
          </button>
          <span *ngIf="msnDetails?.tax_percentage">
            &nbsp;&nbsp;&nbsp;( HSN - {{ msnDetails?.hsn || 'N/A' }} ,
            &nbsp; Tax - {{ msnDetails?.tax_percentage }}% ,
            &nbsp; Items In Pack - {{ msnDetails?.itemInPack || 'N/A' }} ,
            &nbsp; UOM - {{ msnDetails?.uom || 'N/A' }} )
          </span>
          <span *ngIf="!msnDetails?.tax_percentage">
            &nbsp;&nbsp;&nbsp;( HSN - {{ msnDetails?.hsn || 'N/A' }} ,
            &nbsp; Tax - N/A )
          </span>
        </h2>

        <p style="font-size: 10px;">
          {{msnDetails?.msnName}}
        </p>
      </div>
    </div>
  </div>

  <section class="mat-hide-collapse-table-overflow" tabindex="0" infiniteScroll [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="8" (scrolled)="onScroll()" [infiniteScrollDisabled]="isFullListDisplayed"
    [scrollWindow]="false">



    <table mat-table [dataSource]="dataSource" multiTemplateDataRows
      class="mat-hide-collapse-table mat-table mog3_msnsearchtable product-sourcing-detail-table" style="width: 100%;">
      <ng-container matColumnDef="Supplier Id/Name">
        <th mat-header-cell *matHeaderCellDef class="table-width-p170">Supplier Id/Name</th>
        <td mat-cell *matCellDef="let element" class="table-width-p170">
          <span class="font-600 link">{{element.supplierId}} <span *ngIf="element?.passStatus === true" class="pass-badge">
  PAAS
</span>
            <button mat-icon-button class="copy-button ms-2" (click)="copyToClipboard(element?.supplierId, copyTooltip)"
              matTooltip="Copy Supplier ID" #copyTooltip="matTooltip" matTooltipPosition="above">
              <mat-icon class="copy-icon">content_copy</mat-icon>
            </button> </span><br />
          <span class="link" (click)="supplierPage(element.supplierId)">{{ element['supplierName'] }}</span>

        </td>
      </ng-container>

      <ng-container matColumnDef="Address">
        <th mat-header-cell *matHeaderCellDef class="table-width-p150">Address</th>
        <td mat-cell *matCellDef="let element" class="table-width-p150">
          <!-- <span>{{ element?.defaultSupplierAddress || '-'}}</span> -->
          <span>
            {{ showFullAddress ? element?.defaultSupplierAddress : element?.defaultSupplierAddress | slice:0:30 }}
            <span *ngIf="!element?.defaultSupplierAddress">-</span>
          </span>
          <button class="read-more" *ngIf="element?.defaultSupplierAddress" (click)="toggleAddress()">
            {{ showFullAddress ? 'Read Less' : 'Read More' }}
          </button>
        </td>
      </ng-container>


      <ng-container matColumnDef="City">
        <th mat-header-cell *matHeaderCellDef>City</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element?.defaultSupplierCity || '-'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="EmailId">
        <th mat-header-cell *matHeaderCellDef class="table-width-p100">Email Id</th>
        <td mat-cell *matCellDef="let element" class="table-width-p100">
          {{ element?.supplierEmailId || '-'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="Contact">
        <th mat-header-cell *matHeaderCellDef>Contact</th>
        <td mat-cell *matCellDef="let element">
          {{ element.supplierContactNo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Pickup Warehouse City">
        <th mat-header-cell *matHeaderCellDef>
          Pickup Warehouse <br> City
          <i class="ri-arrow-down-s-fill" mat-icon-button [matMenuTriggerFor]="menu" style="cursor: pointer;"
            [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"></i>
          <mat-menu #menu="matMenu">
            <div class="mat-menu-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <mat-form-field class="mog3_matinput select-search" appearance="outline">
                <input matInput placeholder="Search" [(ngModel)]="searchInput" />
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                  <path
                    d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"
                    fill="rgba(111,111,112,1)"></path>
                </svg>
              </mat-form-field>
              <div class="tooltip">
                <mat-option class="menu-dropdown" *ngFor="let warehouseDetail of warehouseDetails | filter:searchInput"
                  (click)="$event.stopPropagation()">
                  <mat-checkbox class="mr-10" (click)="$event.stopPropagation()"
                    (change)="onWareHouseSelectionChange(warehouseDetail, $event.checked)"
                    [checked]="warehouseDetail.checked">
                    <span class="warehouse-city">
                      {{ warehouseDetail.warehouseCity }}</span><span [attr.title]="warehouseDetail.warehouseAddress"
                      data-bs-toggle="tooltip" style="color: #36454F;font-size: 9.5px;"> ({{
                      truncateText(warehouseDetail.warehouseAddress, 33) }})
                    </span>
                  </mat-checkbox>
                </mat-option>
              </div>

            </div>
            <div class="filter-btn-section">
              <button class="filter-btn clear" (click)="clearWarehouseClick($event)">Clear</button>
              <button class="filter-btn apply" (click)="warehouseClick();">Apply</button>
            </div>
          </mat-menu>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.pickupWarehouseCity }}</td>

      </ng-container>

      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef>Material</th>
        <td mat-cell *matCellDef="let element">
          {{ element.material }}
        </td>
      </ng-container>

      <ng-container matColumnDef="LastTransactionDate">
        <th mat-header-cell *matHeaderCellDef>
          Last Transaction <br> Date
          <div class="sorting-btn" (click)="toggleSort()">
            <i [ngClass]="{
              'ri-sort-desc': sortAscending == true,
              'ri-sort-asc': sortAscending == false
            }"></i>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.lastTransactionDate }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="LastTP">
        <th mat-header-cell *matHeaderCellDef>Last TP</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.lastTp }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="CreditDays">
        <th mat-header-cell *matHeaderCellDef>CreditDays</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.creditTermId==0">-</span>
          <span *ngIf="element.creditTermId!==0">{{ creditTermDetailsMap[element.creditTermId]['creditTermDays']
            }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="CountOfTransaction">
        <th mat-header-cell *matHeaderCellDef>Transaction <br> Count</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.countOfTransactions }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="DebitBalance">
        <th mat-header-cell *matHeaderCellDef>
          <div class="d-flex">


            <span>
              Debit Balance(₹)
            </span>


            <a class="toggle-btn collapse-all-btn">
              <!-- <img [src]="ToggleimageSource" alt=""> -->

            </a>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.debitBalance }}</span>

        </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumns.length"
          [ngClass]="{'cell-grey': expandedElement === element}">
          <a class="row-hide-collapse-btn"
            (click)="expandedElement = expandedElement === element ? null : element; getSupplierTransactionDetails(element.supplierId)">
            <i
              [ngClass]="{'ri-subtract-fill': expandedElement === element, 'ri-add-fill': expandedElement !== element}"></i>
          </a>
          <div class="example-element-detail w-full"
            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
            <table mat-table [dataSource]="dataSource2" class="w-full internal-table">
              <ng-container matColumnDef="TimeAndDate">
                <th mat-header-cell *matHeaderCellDef>
                  Time and Date
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.createdAt }}
                </td>
              </ng-container>

              <ng-container matColumnDef="CPONo">
                <th mat-header-cell *matHeaderCellDef>CPO No.</th>
                <td mat-cell *matCellDef="let element">
                  <span class="link font-500"> {{ element.cpoNo }} </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="ProductName">
                <th mat-header-cell *matHeaderCellDef>Product Name</th>
                <td mat-cell *matCellDef="let element">
                  {{ msnDetails?.msnName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="Pickup Warehouse City">
                <th mat-header-cell *matHeaderCellDef>Pickup Warehouse City</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.pickupWarehouseCity }}
                </td>
              </ng-container>

              <ng-container matColumnDef="ContactPerson">
                <th mat-header-cell *matHeaderCellDef>Contact Person</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.supplierContactName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="TP">
                <th mat-header-cell *matHeaderCellDef>TP</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.lastTp }}
                </td>
              </ng-container>

              <ng-container matColumnDef="SP">
                <th mat-header-cell *matHeaderCellDef>SP</th>
                <td mat-cell *matCellDef="let element">{{ element.salesPrice }}</td>
              </ng-container>

              <ng-container matColumnDef="PaymentType">
                <th mat-header-cell *matHeaderCellDef>Payment Type</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.paymentType }}
                </td>
              </ng-container>

              <ng-container matColumnDef="MRN">
                <th mat-header-cell *matHeaderCellDef>MRN Days<p style="font-size: 10px;">(SPO Date - MRN Date)</p>
                </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.mrnDays!=null">{{ element.mrnDays }}</span>
                  <span *ngIf="element.mrnDays==null">-</span>
                  <span></span>
                </td>
              </ng-container>

              <ng-container matColumnDef="LeadTime">
                <th mat-header-cell *matHeaderCellDef>Lead Time</th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.leadTime==null">-</span>
                  <span>{{ element.leadTime }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="DeliveryType">
                <th mat-header-cell *matHeaderCellDef>Delivery Type</th>
                <td mat-cell *matCellDef="let element">
                  <span>{{ element.deliveryType }}</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayColumns2; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayColumns2"></tr>
            </table>
          </div>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns;" class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expand']" class="example-detail-row"></tr>
    </table>

  </section>



  <!-- <section class="mog3_msnsearchtable detail-table" tabindex="0" infiniteScroll [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="8" (scrolled)="onScroll()" [infiniteScrollDisabled]="isFullListDisplayed"
    [scrollWindow]="false">
    <mat-accordion class="icon-accordion border-saperate-accordion" >
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="Supplier Id/Name">
        <th mat-header-cell *matHeaderCellDef>Supplier Id/Name</th>
        <td mat-cell *matCellDef="let element">
          <span class="font-600 link">{{element.supplierId}} </span><br />
          <span class="link" (click)="supplierPage(element.supplierId)">{{ element['supplierName'] }}</span>

        </td>
      </ng-container>

      <ng-container matColumnDef="Address">
        <th mat-header-cell *matHeaderCellDef>Address</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element?.defaultSupplierAddress || '-'}}</span>
        </td>
      </ng-container>


      <ng-container matColumnDef="City">
        <th mat-header-cell *matHeaderCellDef>City</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element?.defaultSupplierCity || '-'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="EmailId">
        <th mat-header-cell *matHeaderCellDef>Email Id</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.supplierEmailId || '-'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="Contact">
        <th mat-header-cell *matHeaderCellDef>Contact</th>
        <td mat-cell *matCellDef="let element">
          {{ element.supplierContactNo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Pickup Warehouse City">
        <th mat-header-cell *matHeaderCellDef>
          Pickup Warehouse City
          <i class="ri-arrow-down-s-fill" mat-icon-button [matMenuTriggerFor]="menu" style="cursor: pointer;"
            [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"></i>
          <mat-menu #menu="matMenu">
            <div class="mat-menu-panel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <mat-form-field class="mog3_matinput select-search" appearance="outline">
                <input matInput placeholder="Search" [(ngModel)]="searchInput" />
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                  <path
                    d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"
                    fill="rgba(111,111,112,1)"></path>
                </svg>
              </mat-form-field>
              <div class="tooltip">
                <mat-option class="menu-dropdown" *ngFor="let warehouseDetail of warehouseDetails | filter:searchInput"
                  (click)="$event.stopPropagation()">
                  <mat-checkbox class="mr-10" (click)="$event.stopPropagation()"
                    (change)="onWareHouseSelectionChange(warehouseDetail, $event.checked)"
                    [checked]="warehouseDetail.checked">
                    <span class="warehouse-city">
                      {{ warehouseDetail.warehouseCity }}</span><span [attr.title]="warehouseDetail.warehouseAddress"
                      data-bs-toggle="tooltip" style="color: #36454F;font-size: 9.5px;"> ({{
                      truncateText(warehouseDetail.warehouseAddress, 33) }})
                    </span>
                  </mat-checkbox>
                </mat-option>
              </div>

            </div>
            <div class="filter-btn-section">
              <button class="filter-btn clear" (click)="clearWarehouseClick($event)">Clear</button>
              <button class="filter-btn apply" (click)="warehouseClick();">Apply</button>
            </div>
          </mat-menu>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.pickupWarehouseCity }}</td>

      </ng-container>

      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef>Material</th>
        <td mat-cell *matCellDef="let element">
          {{ element.material }}
        </td>
      </ng-container>

      <ng-container matColumnDef="LastTransactionDate">
        <th mat-header-cell *matHeaderCellDef>
          Last Transaction Date
          <div class="sorting-btn" (click)="toggleSort()">
            <i [ngClass]="{
                  'ri-sort-desc': sortAscending == true,
                  'ri-sort-asc': sortAscending == false
                }"></i>
          </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.lastTransactionDate }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="LastTP">
        <th mat-header-cell *matHeaderCellDef>Last TP</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.lastTp }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="CreditDays">
        <th mat-header-cell *matHeaderCellDef>CreditDays</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.creditTermId==0">-</span>
          <span *ngIf="element.creditTermId!==0">{{ creditTermDetailsMap[element.creditTermId]['creditTermDays']
            }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="CountOfTransaction">
        <th mat-header-cell *matHeaderCellDef>Count Of Transaction</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.countOfTransactions }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="DebitBalance">
        <th mat-header-cell *matHeaderCellDef>Debit Balance(₹)</th>
        <td mat-cell *matCellDef="let element">
          <span>{{ element.debitBalance }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef><mat-icon>library_add</mat-icon></th>
        <td mat-cell *matCellDef="let element">
          <span>

              <mat-expansion-panel  [expanded]="!panelOpenState" (opened)="getSupplierTransactionDetails(element.supplierId)">
                <mat-expansion-panel-header>
                  <mat-panel-title>                              
                  </mat-panel-title>                      
                </mat-expansion-panel-header>
                
                <span>
                
                
                <table mat-table [dataSource]="dataSource2">
                <ng-container matColumnDef="TimeAndDate">
                <th mat-header-cell *matHeaderCellDef>
                Time and Date
                <div class="sorting-btn" (click)="toggleSort()">
                  <i
                    [ngClass]="{
                      'ri-sort-desc': sortAscending == true,
                      'ri-sort-asc': sortAscending == false
                    }"
                  ></i>
                </div>
                </th>
                <td mat-cell *matCellDef="let element">
                {{ element.createdAt }}
                </td>
                </ng-container>

                <ng-container matColumnDef="CPONo">
                <th mat-header-cell *matHeaderCellDef>CPO No.</th>
                <td mat-cell *matCellDef="let element">
                <span class="link font-500"> {{ element.cpoNo }} </span>
                </td>
                </ng-container>

                <ng-container matColumnDef="ProductName">
                <th mat-header-cell *matHeaderCellDef>Product Name</th>
                <td mat-cell *matCellDef="let element">
                {{ msnDetails?.msnName }}
                </td>
                </ng-container>

                <ng-container matColumnDef="ContactPerson">
                <th mat-header-cell *matHeaderCellDef>Contact Person</th>
                <td mat-cell *matCellDef="let element">
                {{ element.supplierContactName }}
                </td>
                </ng-container>

                <ng-container matColumnDef="TP">
                <th mat-header-cell *matHeaderCellDef>TP</th>
                <td mat-cell *matCellDef="let element">
                {{ element.lastTp }}
                </td>
                </ng-container>
 
                <ng-container matColumnDef="SP">
                <th mat-header-cell *matHeaderCellDef>SP</th>
                <td mat-cell *matCellDef="let element">{{ element.salesPrice }}</td>
                </ng-container>

                <ng-container matColumnDef="PaymentType">
                <th mat-header-cell *matHeaderCellDef>Payment Type</th>
                <td mat-cell *matCellDef="let element">
                {{ element.paymentType }}
                </td>
                </ng-container>

                <ng-container matColumnDef="MRN">
                <th mat-header-cell *matHeaderCellDef>MRN Days<p style="font-size: 10px;">(SPO Date - MRN Date)</p></th>
                <td mat-cell *matCellDef="let element">
                <span *ngIf="element.mrnDays!=null">{{ element.mrnDays }}</span>
                <span *ngIf="element.mrnDays==null">-</span>
                <span></span>
                </td>
                </ng-container>

                <ng-container matColumnDef="LeadTime">
                <th mat-header-cell *matHeaderCellDef>Lead Time</th>
                <td mat-cell *matCellDef="let element">
                <span *ngIf="element.leadTime==null">-</span>
                <span>{{ element.leadTime }}</span>
                </td>
                </ng-container>
                <ng-container matColumnDef="DeliveryType">
                <th mat-header-cell *matHeaderCellDef>Delivery Type</th>
                <td mat-cell *matCellDef="let element">
                <span>{{ element.deliveryType }}</span>
                </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns2; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns2" ></tr>
                </table>               
                                </span>
                
              </mat-expansion-panel>                    
            
          </span>
        </td>
      </ng-container>

      

      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    </table>                    
  </mat-accordion>
    <span *ngIf="dataSource.length===0 && dataload===false">No Supplier Found</span>
    <span *ngIf="dataSource.length===0 && dataload===true">Supplier Detail loading...</span>
  </section> -->
</div>